import React from 'react';
import { defaultPolicyPremiumDetailsData } from 'types/order/title/IPolicyPremiumDetailsResponse';
import { useSelectCurrentOrder } from 'selectors/order/selectCurrentOrder';
import { eTransactionCategory } from '../../../../ui-toolkit/enums/eTransactionType';
import { useParams } from 'react-router-dom';
import { UUID } from '../../../../types/shared/UUID';
import { Card, Grid, Header2Text, Tooltip } from '../../../../ui-toolkit';
import { DisclosedAndActualContainer } from './DisclosedAndActual/DisclosedAndActualContainer';
import { ErrorMessageTW } from '../../../../tailwindComponents/errorMessage/ErrorMessageTW';
import { FontAwesomeIconColor } from '../../../shared/FontAweomeIconColor/FontAwesomeIconColor';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { LoadingSpinnerTW } from '../../../../tailwindComponents/loadingSpinnerTW/LoadingSpinnerTW';
import { PolicyTypesInfoContainer } from './TitlePolicyPremiumDetailsForms/PolicyTypesInfoContainer/PolicyTypesInfoContainer';
import { PercentageFormsContainer } from './TitlePolicyPremiumDetailsForms/PercentageFormsContainer/PercentageFormsContainer';
import { useGetPolicyPremiumDetailsQuery } from '../../../../API/order/title/PolicyPremiumDetailsAPI';
import styled from 'styled-components';

export const TitlePolicyPremiumDetailsContainer: React.FC = () => {
  const { orderId } = useParams<{ orderId: UUID }>();
  const {
    data: { enabled } = defaultPolicyPremiumDetailsData,
    error,
    isLoading,
  } = useGetPolicyPremiumDetailsQuery(orderId);

  const { data, fetchStatus } = useSelectCurrentOrder();

  // NOTE:
  // After PP-269, the component will be rendered for Refinance orders.
  // But, certain components will be rendered; others will not.
  if (
    !fetchStatus.success ||
    data.transaction.transaction_category === eTransactionCategory.Refinance ||
    enabled === false
  ) {
    return null;
  }

  return (
    <LoadingSpinnerTW isLoading={isLoading}>
      <Card title={<PolicyPremiumDetailsHeadline />}>
        <GrayLineGrid>
          <ErrorMessageTW rtkError={error} />
          <PolicyTypesInfoContainer />
          <PercentageFormsContainer />
          <DisclosedAndActualContainer />
        </GrayLineGrid>
      </Card>
    </LoadingSpinnerTW>
  );
};

const PolicyPremiumDetailsHeadline = () => (
  <>
    <Header2Text> Policy Premium Details</Header2Text>
    <Tooltip tooltipContent={'Changes made here will update applicable fees.'} trigger={'hover'}>
      <FontAwesomeIconColor intent={'secondary'} icon={faInfoCircle} />
    </Tooltip>
  </>
);

const GrayLineGrid = styled(Grid)`
  & > * {
    padding-top: ${({ theme }) => theme.spacing.spacing5};
    border-top: 1px solid ${({ theme }) => theme.colors.gray};
  }
`;
